/* eslint-disable */
import { defineStore } from "pinia";
import _ from "lodash";
import { MyBets } from "./MyBets.js";
import * as Combinatorics from "js-combinatorics";

import { applyPatch } from "rfc6902";
import { useSocketStore } from '@/stores/socket';
import { useCustomerStore } from "@/stores/customer.js";
import { useMissionsStore } from "./missions.js";
import { openModal } from '@kolirt/vue-modal';
import MissionCompletion from "@/components/modals/missions/MissionCompletion.vue";
import { useSharedBetslipsStore } from "@/stores/shared_betslips.js";
import { useAccaBoostStore } from "./acca_boost.js";
import { i18n } from '@/main'
import { useLanguagesStore } from "./languages.js";
import { useCurrenciesStore } from "./currencies.js";
import { useBonusStore } from "./bonus.js";

export const BetSlip = defineStore({ id: "BetSlip",
	state: () => ({
		uni_limits: {},
		betslip_tax: 0,
		is_betslip_opened: false,
		tab_setted: false,
		same_fixture_error_message: false,
		betSlipModel: "",
		selectedTab: "singles",
		numpad_opened: false,
		// numKeyPad: [1, 2, 3, 4, 5, 6, 7, 8, 9, ".", 0],
		betslip: {
			type: "singles",
			bets: {},
			placed: false,
			error_message: null,
			multiple_freebet_id: null,
			multiple_stake: 0,
			systemX2_stake: 0,
			systemX3_stake: 0,
			systemX4_stake: 0,
			systemX5_stake: 0,
			systemX6_stake: 0,
			systemX7_stake: 0,
			systemX8_stake: 0,
			systemX9_stake: 0,
			systemX10_stake: 0,
			systemX11_stake: 0,
			systemX12_stake: 0,
			systemX13_stake: 0,
			systemX14_stake: 0,
			system_singles_stake: 0,
			system_multiple_stake: 0,
		},
		processing_placement: false,
		betslip_deleted: false,
		show_partial_cashout: false,
		partial_cashout_amount: 0,
		max_betslip_bets: 50,
		share_id: null,
		betslip_placed_ids: []
	}),
	getters: {
		getMaxReturn: (state) => (betslip_return, multiple_stake = 0) => {
			const currenciesStore = useCurrenciesStore();
			if (!currenciesStore.getSelectedCurrency.bet_max_profit) {
				return betslip_return;
			}

			const value_to_check = (Number(currenciesStore.getSelectedCurrency.bet_max_profit)) * state.getMinPercentageLimit;
			if (Number(betslip_return) - multiple_stake > value_to_check) {
				return Number(value_to_check) + Number(multiple_stake);
			}

			return betslip_return;
		},
		hasMaxReturn: (state) => (betslip_return, multiple_stake = 0) => {
			const currenciesStore = useCurrenciesStore();
			if (!currenciesStore.getSelectedCurrency.bet_max_profit) {
				return false
			}

			const value_to_check = (Number(currenciesStore.getSelectedCurrency.bet_max_profit)) * state.getMinPercentageLimit;
			if (Number(betslip_return) - multiple_stake > value_to_check) {
				return true;
			}

			return false
		},
		getMinPercentageLimit(state) {
			if (Object.keys(state.uni_limits).length == 0) return 1;
			return _.min(Object.values(state.uni_limits));
		},
		isOddInBetslip: (state) => (odd_uuid, boosted = false) => {
			const bet = state.betslip.bets[odd_uuid];
			if (!bet) return false;

			const is_boosted = Boolean(bet.odd_info?.campaign_id && bet.odd_info?.boosted_price);
			return boosted ? is_boosted : !is_boosted;
		},
		isBoostedOddInBetslip: (state) => (odd_uuid) => {
			const bet = state.betslip.bets[odd_uuid];
			if (!bet) return false;

			return Boolean(bet.odd_info?.campaign_id && bet.odd_info?.boosted_price);
		},
		isOddSuspended: () => (odd) => {
			if (!odd) return true;
			else if (odd.hasOwnProperty("status") && odd.status == "suspended") return true;

			else return false;
		},
		isBetslipOpened(state) {
			return state.is_betslip_opened;
		},
		getSelectedTab(state) {
			return state.betslip.type;
		},
		countBetslipBets(state) {
			return Object.keys(state.betslip.bets).length;
		},
		singleBetslipEligibleFreebets: (state) => (uuid) => {
			const customerStore = useCustomerStore();
			let bet_cloned = _.cloneDeep(state.betslip.bets[uuid]);

			let eligible_freebets = [];
			for (const freebet of customerStore.freebets) {
				if (freebet.minimum_selections > 1) continue;
				if (freebet.minimum_odd_price > bet_cloned.price) continue;

				if (freebet.odd_type == "live" && !bet_cloned.odd_info.live) continue;
				if (freebet.odd_type == "pre" && bet_cloned.odd_info.live) continue;

				if (freebet.eligible_sports.length > 0) {
					if (!freebet.eligible_sports.includes(bet_cloned.odd_info.sport_id)) continue;
				}

				if (freebet.eligible_competitions.length > 0) {
					if (!freebet.eligible_competitions.includes(Number(bet_cloned.odd_info.competition_id))) continue;
				}

				// Check market id
				// Check if I have permission for this market
				let market_permission = _.find(freebet.markets, {'market_id': bet_cloned.odd_info.market_external_id });
				if (market_permission) {
					if (market_permission.permission == 'deny') continue;
				} else {
					// Now check global freebet market permission
					let global_permission = _.find(freebet.markets, {'market_id': 0 });
					if (global_permission) {
						if (global_permission.permission == 'deny') continue;
					}
				}

				// Check fixture id
				// Check if I have permission for this fixture
				let fixture_permission = _.find(freebet.fixtures, {'fixture_id': bet_cloned.odd_info.fixture_id });
				if (fixture_permission) {
					if (fixture_permission.permission == 'deny') continue;
				} else {
					// Now check global freebet market permission
					let global_permission = _.find(freebet.fixtures, {'fixture_id': 0 });
					if (global_permission) {
						if (global_permission.permission == 'deny') continue;
					}
				}

				eligible_freebets.push(freebet);
			}

			return eligible_freebets;
		},
		multipleBetslipEligibleFreebets(state) {
			const customerStore = useCustomerStore();

			let eligible_freebets = [];
			for (const freebet of customerStore.freebets) {
				if (freebet.minimum_selections > state.countBetslipBets) continue;

				let elegible_freebet = true;
				let betslip_price = 1;
				for (const bet_uuid in state.betslip.bets) {
					if (Object.hasOwnProperty.call(state.betslip.bets, bet_uuid)) {
						const bet = state.betslip.bets[bet_uuid];
						betslip_price = betslip_price * bet.price;

						if (Number(freebet.minimum_odd_price) > Number(bet.price)) {
							elegible_freebet = false;
							continue;
						}

						if (freebet.odd_type == "live" && !bet.odd_info.live) {
							elegible_freebet = false;
							continue;
						}

						if (freebet.odd_type == "pre" && bet.odd_info.live) {
							elegible_freebet = false;
							continue;
						}

						if (freebet.eligible_sports.length > 0) {
							if (!freebet.eligible_sports.includes(bet.odd_info.sport_id)) {
								elegible_freebet = false;
								continue;
							}
						}

						if (freebet.eligible_competitions.length > 0) {
							if (!freebet.eligible_competitions.includes(Number(bet.odd_info.competition_id))) {
								elegible_freebet = false;
								continue;
							}
						}

						// Check market id
						// Check if I have permission for this market
						let market_permission = _.find(freebet.markets, {'market_id': bet.odd_info.market_external_id });
						if (market_permission) {
							if (market_permission.permission == 'deny') {
								elegible_freebet = false;
								continue;
							}
						} else {
							// Now check global freebet market permission
							let global_permission = _.find(freebet.markets, {'market_id': 0 });
							if (global_permission) {
								if (global_permission.permission == 'deny') {
									elegible_freebet = false;
									continue;
								}
							}
						}

						// Check fixture id
						// Check if I have permission for this fixture
						let fixture_permission = _.find(freebet.fixtures, {'fixture_id': bet.odd_info.fixture_id });
						if (fixture_permission) {
							if (fixture_permission.permission == 'deny') {
								elegible_freebet = false;
								continue;
							}
						} else {
							// Now check global freebet market permission
							let global_permission = _.find(freebet.fixtures, {'fixture_id': 0 });
							if (global_permission) {
								if (global_permission.permission == 'deny') {
									elegible_freebet = false;
									continue;
								}
							}
						}
					}
				}

				// Check betslip price
				if (freebet.minimum_odd_price_betslip > betslip_price) elegible_freebet = false;

				if (elegible_freebet) eligible_freebets.push(freebet);
			}

			return eligible_freebets;
		},
		calculateTotalStakes(state) {
			let single_bet_stakes = 0;
			let system_stakes = 0;

			for (const bet_uuid in state.betslip.bets) {
				if (Object.hasOwnProperty.call(state.betslip.bets, bet_uuid)) {
					const bet = state.betslip.bets[bet_uuid];

					if (!isNaN(bet.stake)) single_bet_stakes += Number(bet.stake);
				}
			}

			if (Object.keys(state.betslip.bets).length > 2) {
				for (let index = 2; index <= Object.keys(state.betslip.bets).length; index++) {
					let system_stake = state.betslip['systemX' + index + '_stake'];
					let combinations = Combinatorics.Combination.of(Object.values(state.betslip.bets), index);

					system_stake = Number(system_stake) * Number(combinations.length);

					if (!isNaN(system_stake)) system_stakes += Number(system_stake);
				}
			}

			let multiple_stake = state.betslip.multiple_stake;
			if (isNaN(multiple_stake)) multiple_stake = '0.00';

			let system_singles_stake = state.betslip.system_singles_stake;
			if (isNaN(system_singles_stake)) system_singles_stake = '0.00';

			let system_multiple_stake = state.betslip.system_multiple_stake;
			if (isNaN(system_multiple_stake)) system_multiple_stake = '0.00';

			let total_stake = Number(single_bet_stakes) + Number(multiple_stake) + Number(system_stakes) + Number(system_singles_stake) + Number(system_multiple_stake);

			return total_stake;
		},
		hasSPOdd(state) {
			let sp_odd_bets = _.filter(state.betslip.bets, function (betslip_bet) {
				return betslip_bet.odd_info.sp == true;
			});

			if (sp_odd_bets.length > 0) return true;

			return false;
		},
		getBetsScale(state){
			const accaBoostStore = useAccaBoostStore();
			const betScale = accaBoostStore.getAccaBoostScale.find((s)=> s.bet_selections === state.countBetslipBets)

			return betScale;
		},
		getAccaBoostPromtMessage(state){
			const accaBoostStore = useAccaBoostStore();
			const accaBoostMsgData = [];

			if (state.countBetslipBets + 1  === accaBoostStore.getAccaBoostScale[0]?.bet_selections) {
				 accaBoostMsgData[0] = `${accaBoostStore.getAccaBoostScale[0].boost_percentage}`;
				 return accaBoostMsgData;
			}

			if (state.getBetsScale && state.isAccaBoostEligible) {
				var indexOfCurrentScale = accaBoostStore.getAccaBoostScale.findIndex(scale => scale.boost_percentage === state.getBetsScale.boost_percentage);
				accaBoostMsgData[0] = `${state.getBetsScale.boost_percentage}`;
				accaBoostMsgData[1] = `${accaBoostStore.getAccaBoostScale[indexOfCurrentScale + 1].boost_percentage}`;
				return accaBoostMsgData;
			}

			return accaBoostMsgData;
		},
		isAccaBoostEligible(state){
			const customerStore = useCustomerStore();
			const accaBoostStore = useAccaBoostStore();

			let bets = _.map(state.betslip.bets, function (betslip_bet) {
				return betslip_bet;
			});

			if (state.betslip.type !== "multiple") {
				return false;
			}

			if (state.betslip.multiple_freebet_id !== null) {
				return false;
			}

			if (customerStore.activeBonuses && customerStore.activeBonuses.length > 0 ) {
				return false;
			}

			const innaccessibleMarkets = bets.filter(bet => !accaBoostStore.getAvailableMarkets.includes(bet.odd_info.market_external_id));
			if (innaccessibleMarkets.length > 0) {
				return false
			}

			const inaccessibleOdds = bets.filter((bet)=> parseFloat(bet.price) < parseFloat(accaBoostStore.accaBoostScale[0].min_odd))
			if (inaccessibleOdds.length > 0) {
				return false;
			}

			return true;
		},
		isBetslipEditable: (state) => (betslip) => {
			return (
				betslip.edit_bet_available &&
				!betslip.settlement &&
				betslip.cashout_amount &&
				betslip.cashout_available &&
				!betslip.is_mission_betslip &&

				!betslip.bonus_stake &&
				!betslip.bonus_id &&
				!betslip.freebet_id
			);
		}
	},
	actions: {
		setBetslipTax(data) {
			this.betslip_tax = data;
		},
		toggleBetslip() {
			this.is_betslip_opened = !this.is_betslip_opened;
		},
		setSelectedTab(tab) {
			this.betslip.type = tab;
			for (const uuid in this.betslip.bets) {
				const bet = this.betslip.bets[uuid];
				if (bet && bet.odd_info) {
					if (tab === "singles") {
						if (bet.odd_info.campaign_id && bet.odd_info.boosted_price) {
							bet.price = bet.odd_info.boosted_price;
						}
					} else {
						bet.price = bet.odd_info.price;
					}
				}
			}
		},
		async toggleToBetslip(payload, shared_betslip_id, shared_id, boosted = false) {

			const socketStore = useSocketStore();

			if (this.betslip.placed == true) {
				this.resetBetslip();
			}

			if (this.betslip.bets.hasOwnProperty(payload.odd_uuid)) {
				const existing_bet = this.betslip.bets[payload.odd_uuid];
				const existing_is_boosted = Boolean(existing_bet.odd_info?.campaign_id && existing_bet.odd_info?.boosted_price);
				const incoming_is_boosted = Boolean(boosted || payload.campaign_id);

				if (existing_is_boosted === incoming_is_boosted) {
					payload.market_uuid = existing_bet.odd_info ? existing_bet.odd_info.market_uuid : null;
					this.removeFromBetslip(payload);
					if (Object.keys(this.betslip.bets).length == 0) {
						this.betSlipModel = "";
					}

					return;
				}
			}

			if (Object.keys(this.betslip.bets).length >= this.max_betslip_bets) {
				if (this.betSlipModel == "") this.betSlipModel = 'betslip';
				return;
			}

			return global.axios.get(process.env.VUE_APP_SPORTSBOOK_API_URL + '/odds/info/?fixture_id=' + payload.fixture_id + '&odd_uuid=' + payload.odd_uuid + '&boosted=' + Boolean(boosted), { withCredentials: false }).then(async (response) => {
				const is_boosted = Boolean(boosted && ((response.data.campaign_id && response.data.boosted_price) || payload.campaign_id));
				const effective_price = (is_boosted && this.betslip.type === "singles" && response.data.boosted_price) ? response.data.boosted_price : response.data.price;

				let bet = {
					odd_info: response.data,
					price: effective_price,
					has_error: false,
					stake: this.betslip.bets[payload.odd_uuid]?.stake || 0,
					freebet_id: null,
					is_boosted: is_boosted
				}

				if (is_boosted) {
					if (response.data.campaign_id || payload.campaign_id) bet.campaign_id = response.data.campaign_id || payload.campaign_id;
					if (response.data.boosted_price) bet.boosted_price = response.data.boosted_price;
				} else {
					delete bet.campaign_id;
					delete bet.boosted_price;
					if (bet.odd_info) {
						delete bet.odd_info.campaign_id;
						delete bet.odd_info.boosted_price;
					}
				}

				if (useCustomerStore().isLoggedIn) {
					this.fetchUniLimit(bet)
				}

				this.betslip.bets[bet.odd_info.uuid] = bet;
				socketStore.join('fixtureOddInfo', { fixture_id: bet.odd_info.fixture_id, odd_uuid: bet.odd_info.uuid })

				// open betslip if is first bet
				if (this.countBetslipBets == 1) this.betSlipModel = "betslip";

				if (shared_id) this.share_id = shared_id;
				return Promise.resolve(response.data);
			}).catch((error) => {
				if (shared_betslip_id) {
					// this.resetBetslip();
					return Promise.reject(error.response.data);
				} else {
					alert('Cannot Place Bet');
					console.log(error);
					return Promise.reject(error.response.data);
				}
			});
		},
		async fetchUniLimit(bet) {
			const limit_response = await axios.post(process.env.VUE_APP_API_URL + '/betslip/tunover-limit', bet.odd_info, { headers: {'Content-Type' : 'application/json'} });
			this.uni_limits[bet.odd_info.id] = limit_response.data.limit;
		},
		resetBetslip() {
			this.leaveOddInfos();

			// reset betslip state to default
			this.betslip = {
				type: "singles",
				bets: {},
				placed: false,
				error_message: null,
				multiple_freebet_id: null,
				multiple_stake: 0,
				systemX2_stake: 0,
				systemX3_stake: 0,
				systemX4_stake: 0,
				systemX5_stake: 0,
				systemX6_stake: 0,
				systemX7_stake: 0,
				systemX8_stake: 0,
				systemX9_stake: 0,
				systemX10_stake: 0,
				systemX11_stake: 0,
				systemX12_stake: 0,
				systemX13_stake: 0,
				systemX14_stake: 0,
				system_singles_stake: 0,
				system_multiple_stake: 0,
			}
			this.uni_limits = {};
			this.share_id = null;
			this.betslip_placed_ids = [];
			// this.betslip.type = "singles";
			// this.betslip.bets = {};
			// this.betslip.placed = false;
			// this.betslip.error_message = null;
			// this.betslip.multiple_freebet_id = null;
			// this.betslip.multiple_stake = 0;
			// this.betslip.systemX2_stake = 0;
			// this.betslip.systemX3_stake = 0;
			// this.betslip.systemX4_stake = 0;
			// this.betslip.systemX5_stake = 0;
			// this.betslip.systemX6_stake = 0;
			// this.betslip.systemX7_stake = 0;
			// this.betslip.systemX8_stake = 0;
			// this.betslip.systemX9_stake = 0;
			// this.betslip.systemX10_stake = 0;
			// this.betslip.systemX11_stake = 0;
			// this.betslip.systemX12_stake = 0;
			// this.betslip.systemX13_stake = 0;
			// this.betslip.systemX14_stake = 0;
			// this.betslip.system_singles_stake = 0;
			// this.betslip.system_multiple_stake = 0;
		},
		addErrorMessageToBetslip() {
			const { t } = i18n.global
			let error_message =  t('betslip.general_error');
			this.betslip.error_message = error_message;
		},
		removeFromBetslip(payload) {
			if (!this.betslip.bets.hasOwnProperty(payload.odd_uuid)) return;

			delete this.betslip.bets[payload.odd_uuid];
			delete this.uni_limits[payload.odd_uuid];
			this.leaveFixtureOddInfo({ fixture_id: payload.fixture_id, odd_uuid: payload.odd_uuid, market_uuid: payload.market_uuid });

			if (this.countBetslipBets == 1) this.betslip.type = "singles";
			if (this.countBetslipBets >= 2) this.betslip.type = "multiple";

			if (this.countBetslipBets == 0) {
				this.is_betslip_opened = false;
				this.betSlipModel = '';
				this.resetBetslip();
			}
		},
		removeBetslipErrors() {
			for (const odd_uuid in this.betslip.bets) {
				if (Object.hasOwnProperty.call(this.betslip.bets, odd_uuid)) {
					const bet = this.betslip.bets[odd_uuid];

					// Remove if suspended
					if (bet.odd_info.status == "suspended") {
						this.removeFromBetslip({ odd_uuid: bet.odd_info.uuid, fixture_id: bet.odd_info.fixture_id});
						continue;
					}

					// Fix price
					const effectiveOddPrice = (this.betslip.type === "singles" && bet.odd_info?.campaign_id && bet.odd_info?.boosted_price)
						? bet.odd_info.boosted_price
						: bet.odd_info?.price;
					if (this.betslip.bets[odd_uuid].price != effectiveOddPrice) {
						this.betslip.bets[odd_uuid].price = effectiveOddPrice;
					}

					// Remove has error
					this.betslip.bets[odd_uuid].has_error = false;
				}
			}

			// Remove error message from betslip
			this.betslip.error_message = null;
		},
		toggleFreebetOnSingle(payload) {
			// Find if bet already has this freebet
			if (this.betslip.bets[payload.odd_uuid].freebet_id == payload.freebet.id) {
				this.betslip.bets[payload.odd_uuid].freebet_id = null;
				this.betslip.bets[payload.odd_uuid].stake = 0;
			} else {
				// Remove freebet from other bets
				for (const bet_uuid in this.betslip.bets) {
					if (this.betslip.bets[bet_uuid].freebet_id == payload.freebet.id) {
						this.betslip.bets[bet_uuid].freebet_id = null;
						this.betslip.bets[bet_uuid].stake = 0;
					}
				}

				// Add freebet to selected bet
				this.betslip.bets[payload.odd_uuid].freebet_id = payload.freebet.id;
				this.betslip.bets[payload.odd_uuid].freebet_customer_id = payload.freebet.freebet_customer_id;
				this.betslip.bets[payload.odd_uuid].stake = payload.freebet.amount;
			}
		},
		toggleFreebetOnMultiple(freebet) {
			if (this.betslip.multiple_freebet_id == freebet.id && this.betslip.freebet_customer_id == freebet.freebet_customer_id) {
				this.betslip.multiple_freebet_id = null;
				this.betslip.freebet_customer_id = null;
				this.betslip.multiple_stake = 0;

				return;
			}

			this.betslip.multiple_freebet_id = freebet.id;
			this.betslip.freebet_customer_id = freebet.freebet_customer_id;
			this.betslip.multiple_stake = freebet.amount;
		},
		validateSameFixtures() {
			this.same_fixture_error_message = false;
			for (const odd_uuid in this.betslip.bets) {
				if (Object.hasOwnProperty.call(this.betslip.bets, odd_uuid)) {
					const bet = this.betslip.bets[odd_uuid];

					let same_fixtures = _.filter(this.betslip.bets, function ( betslip_bet) {
						return betslip_bet.odd_info.fixture_id == bet.odd_info.fixture_id && betslip_bet.odd_info.uuid != bet.odd_info.uuid;
					});

					if (same_fixtures.length > 0 && this.betslip.type != "singles") {
						for (const same_fixture_bet of same_fixtures) {
							this.betslip.bets[same_fixture_bet.odd_info.uuid].has_error = true;
							this.same_fixture_error_message = true;
						}
					} else {
						this.betslip.bets[odd_uuid].has_error = false;
					}
				}
			}
		},
		socketJoinBets() {
			const socketStore = useSocketStore();

			for (const odd_uuid in this.betslip.bets) {
				if (Object.hasOwnProperty.call(this.betslip.bets, odd_uuid)) {
					const bet = this.betslip.bets[odd_uuid];
					socketStore.join('fixtureOddInfo', { fixture_id: bet.odd_info.fixture_id, odd_uuid: bet.odd_info.uuid });

					let socketUrl = process.env.VUE_APP_SPORTSBOOK_API_URL + '/odds/info/?fixture_id=' + bet.odd_info.fixture_id + '&odd_uuid=' + bet.odd_info.uuid;
					if (bet.odd_info?.campaign_id || bet.campaign_id || bet.boosted || bet.is_boosted) {
						socketUrl += '&boosted=true';
					}
					global.axios.get(socketUrl, { withCredentials: false }).then((response) => {
						this.betslip.bets[odd_uuid].odd_info = response.data;
						if (this.betslip.bets[odd_uuid].is_boosted || bet.campaign_id || bet.boosted) {
							if (response.data.campaign_id) {
								this.betslip.bets[odd_uuid].campaign_id = response.data.campaign_id;
							}
							if (response.data.boosted_price) {
								this.betslip.bets[odd_uuid].boosted_price = response.data.boosted_price;
								if (this.betslip.type === "singles") this.betslip.bets[odd_uuid].price = response.data.boosted_price;
							}
						} else if (this.betslip.bets[odd_uuid].odd_info) {
							delete this.betslip.bets[odd_uuid].odd_info.campaign_id;
							delete this.betslip.bets[odd_uuid].odd_info.boosted_price;
						}
					}).catch((error) => {
						if (error.response && error.response.status == 404) {
							this.addErrorMessageToBetslip();
							this.betslip.bets[odd_uuid].odd_info.status = 'suspended';
						} else {
							console.log(error);
						}
					});
				}
			}
		},
		async placeBetslip() {
			if (this.calculateTotalStakes == 0) {
				return;
			}

			let betslip = _.cloneDeep(this.betslip);

			if (betslip.system_singles_stake > 0) {
				betslip = this.addSingleStakeToBets(betslip);
				betslip.type = null;
			}

			if (betslip.system_multiple_stake > 0) {
				betslip.multiple_stake = betslip.system_multiple_stake;
				betslip.type = null;
			}

			if (this.share_id) betslip.share_id = this.share_id;

			for (const bet of Object.values(betslip.bets)) {
				if (bet.odd_info?.boosted_price) {
					bet.price = bet.odd_info.price;
					bet.boosted_price = bet.odd_info.boosted_price;
					bet.campaign_id = bet.odd_info.campaign_id || bet.campaign_id;
				}
			}

			if (this.calculateTotalStakes == 0) return;
			const customerStore = useCustomerStore();
			const myBetsStore = MyBets();

			this.processing_placement = true;
			global.axios.post(process.env.VUE_APP_API_URL + '/betslip/place', JSON.stringify(betslip), { headers: {'Content-Type' : 'application/json'} }).then((response) => {
				let type = _.cloneDeep(this.betslip.type);


				this.betslip = response.data;
				this.betslip.type = type;
				if (this.betslip.type === "singles") {
					for (const bet of Object.values(this.betslip.bets)) {
						if (bet.odd_info?.boosted_price) bet.price = bet.odd_info.boosted_price;
					}
				}
				this.leaveOddInfos();
				useBonusStore().fetchOffers();
				customerStore.fetchBalance();
				myBetsStore.fetchMyBets();

				if (response.data.completed_mission != null) {
					const missionsStore = useMissionsStore();
					missionsStore.setSelectedMission(response.data.completed_mission);
					openModal(MissionCompletion).then((data) => {}).catch(() =>{});
				}
			}).catch((error) => {
				if (error.response.status == 406 || error.response.status == 401) {
					if (error.response.data) {
						let type = _.cloneDeep(this.betslip.type);
						this.betslip = error.response.data;
						this.betslip.type = type;

						this.addSingleBetsStakeToSystemSingle();
						this.addSingleBetsStakeToSystemMultiple();
					}
				} else {
					console.log(error);
				}
			}).finally(() => {
				this.processing_placement = false;
			});
		},
		addSingleStakeToBets(betslip) {
			for (const key in betslip.bets) {
				if (Object.hasOwnProperty.call(betslip.bets, key)) {
					betslip.bets[key].stake = betslip.system_singles_stake;
				}
			}

			return betslip;
		},
		addSingleBetsStakeToSystemSingle() {
			if (this.betslip.type != 'system') return;
			if (this.betslip.system_singles_stake == 0) return;

			let bet_stakes = [];
			for (const key in this.betslip.bets) {

				if (Object.hasOwnProperty.call(this.betslip.bets, key)) {
					bet_stakes.push(Number(this.betslip.bets[key].stake));
				}
			}

			const min_stake = Math.min(...bet_stakes);
			this.betslip.system_singles_stake = min_stake;
		},
		addSingleBetsStakeToSystemMultiple() {
			if (this.betslip.type != 'system') return;
			if (this.betslip.system_multiple_stake == 0) return;

			this.betslip.system_multiple_stake = this.betslip.multiple_stake
		},

		leaveOddInfos() {
			// leave odd info chanels
			for (const bet_uuid in this.betslip.bets) {
				if (Object.hasOwnProperty.call(this.betslip.bets, bet_uuid)) {
					const bet = this.betslip.bets[bet_uuid];

					this.leaveFixtureOddInfo({fixture_id: bet.odd_info.fixture_id, odd_uuid: bet.odd_info.uuid, market_uuid: bet.odd_info.market_uuid });
				}
			}
		},
		leaveFixtureOddInfo(payload) {
			const socketStore = useSocketStore();
			const myBetsStore = MyBets();
			let found = false;

			let betslips = _.filter(myBetsStore.my_bets, {
				betslip_result: "unsettled",
			});

			for (const element of betslips) {
				const betslip = element;
				let bet = _.find(betslip.bets, { uuid: payload.odd_uuid });
				if (bet) {
					found = true;
					break;
				}
			}

			console.log(payload, 'payload')
			if (!found) socketStore.leave('fixtureOddInfo', { fixture_id: payload.fixture_id, odd_uuid: payload.odd_uuid, market_uuid: payload.market_uuid })
		},
		keepBetslip() {
			this.socketJoinBets();

			this.betslip.placed = false;
			this.betslip.error_message = null;
			this.betslip.multiple_freebet_id = null;
			this.betslip.multiple_stake = 0;
			this.betslip.systemX2_stake = 0;
			this.betslip.systemX3_stake = 0;
			this.betslip.systemX4_stake = 0;
			this.betslip.systemX5_stake = 0;
			this.betslip.systemX6_stake = 0;
			this.betslip.systemX7_stake = 0;
			this.betslip.systemX8_stake = 0;
			this.betslip.systemX9_stake = 0;
			this.betslip.systemX10_stake = 0;
			this.betslip.systemX11_stake = 0;
			this.betslip.systemX12_stake = 0;
			this.betslip.systemX13_stake = 0;
			this.betslip.systemX14_stake = 0;

			for (const uuid in this.betslip.bets) {
				if (Object.hasOwnProperty.call(this.betslip.bets, uuid)) {
					this.betslip.bets[uuid].stake = 0;
					this.betslip.bets[uuid].freebet_id = null;
					if (this.betslip.type === "singles" && this.betslip.bets[uuid].odd_info?.boosted_price) {
						this.betslip.bets[uuid].price = this.betslip.bets[uuid].odd_info.boosted_price;
					}
				}
			}

			this.betslip_placed_ids = [];
		},
		addFixtureOddInfo(data) {
			if (!this.betslip.bets.hasOwnProperty(data.uuid)) return;

			for (const key in data) {
				this.betslip.bets[data.uuid].odd_info[key] = data[key];
			}
		},
		updateFixtureOddInfo(data) {
			const customerStore = useCustomerStore();


			let bet_cloned = _.cloneDeep(this.betslip.bets[data.uuid]);
			if (!bet_cloned) return;

			// Update bet
			applyPatch(bet_cloned.odd_info, data.patch);

			const price = (this.betslip.type === "singles" && bet_cloned.odd_info?.boosted_price) || bet_cloned.odd_info.price;

			// Check price change for always_ask && accept_higher_odds
			if (
			(bet_cloned.price != price &&
				customerStore.betslipChanges == "always_ask") ||
			(bet_cloned.price > price &&
				customerStore.betslipChanges == "accept_higher_odds")
			) {
				this.addErrorMessageToBetslip();
			} else {
				bet_cloned.price = price;
			}

			if (bet_cloned.odd_info.status == "suspended") {
				this.addErrorMessageToBetslip();
			}

			// Add updated bet to betslip
			this.betslip.bets[data.uuid] = bet_cloned;
		},
		deleteFixtureOddInfo(data) {
			if (!this.betslip.bets.hasOwnProperty(data)) return;

			this.addErrorMessageToBetslip();
			this.betslip.bets[data].odd_info.status = "suspended";
		},
		deleteFixtureOddInfoMarket(data) {

			for (const uuid in this.betslip.bets) {
				if (Object.hasOwnProperty.call(this.betslip.bets, uuid)) {
					if (this.betslip.bets[uuid].odd_info.market_uuid == data.market_uuid  && this.betslip.bets[uuid].odd_info.fixture_id == data.fixture_id) {
						this.deleteFixtureOddInfo(uuid);
					}
				}
			}
		},
		removeFreebetSingle(uuid) {
			this.betslip.bets[uuid].freebet_id = null;
			return;
		},
		removeSingleFreebet(uuid) {
			this.betslip.bets[uuid].freebet_id = null;
			this.betslip.bets[uuid].stake = 0;
			return;
		},
		removeFreebet() {
			this.betslip.multiple_freebet_id = null;
			this.betslip.multiple_stake = 0;
			return;
		},
		validateInput(currentValue, type, value) {
			let current_value = String(currentValue || "0");

			switch (type) {
				case "add":
					return String(parseFloat(current_value) + Number(value));

				case "append":
					if (value === ".") {
						return current_value.includes(".") ? current_value : current_value + ".";
					}
					return current_value === "0" ? String(value) : current_value + String(value);

				case "delete":
					return current_value.length > 1 ? current_value.slice(0, -1) : "0";

				default:
					return current_value;
			}
		},
		calculateMaxBet(payload) {
			return axios.post(process.env.VUE_APP_API_URL + '/betslip/max-bet', payload, { headers: {'Content-Type' : 'application/json'} }).then((response) => {
				return Promise.resolve(response.data);
			}).catch((error) => {
				return Promise.reject(error.response.data);
			});
		}
	},

  persist: true,
});
